import view from '@/mixins/view'

import { populate, sort } from '@/data'

export default {
  name: 'single-work',
  mixins: [view],
  data () {
    return {
      page: ''

    }
  },
  created () {
    this.getPage().then(() => {
      if (!this.page) this.$router.push({ name: 'not-found' })

      // split the first text blocks and the rest (for tags insertion)
      if (this.page.meta.blocks) {
        this.page.meta.afterTags = []
        for (var i = 0; i < this.page.meta.blocks.length; i++) {
          if (this.page.meta.blocks[i].type != 'text') break
        }
        this.page.meta.afterTags = this.page.meta.blocks.splice(i)
      }

      this.preloadAssets().then(() => {
        this.ready = true
      })
    })
  },
  methods: {
    fetchData: async function (store, params) {
      return Promise.all([
        store.getters.get(params.post_type, params.slug, true),
        store.getters.get('work'),
        store.getters.get('partner'),
        store.getters.get('activity'),
        store.getters.get('expertise'),
        store.getters.get('post')
      ]).then(([page, works, partners, activities, expertises, posts]) => {
        return { page, works, partners, activities, expertises, posts }
      })
    },
    preloadAssets: async function () {
      return this.fetch(this.getCleanLink(this.getImageUrl(this.page.meta.cover.image_desktop, 'cover-desktop')))
    },
    getPage: async function () {
      await this.fetchData(this.$store, Object.assign({}, this.$attrs, this.$route.params)).then(({ page, works, partners, activities, expertises, posts }) => {
        works = populate(works, partners, 'partner')
        // activities = sort(activities, 'title', 'asc')
        page = populate(page, partners, 'partner')
        page = populate(page, activities, 'activities')
        page.meta.activities = sort(page.meta.activities, 'title', 'asc')
        page = populate(page, expertises, 'expertise')
        page = populate(page, works, 'works')
        page = populate(page, posts, 'posts')
        this.page = page
      })
    }
  }
}
